<script>
	import { serializeSchema } from './json-ld.js';
	import { PUBLIC_WEBSITE_URL } from '$env/static/public';

	//export let schema;
	export let algemeen;
	export let story;

	var seoTitel = story.content.og_title ? story.content.og_title : story.content.titel;
	var seoOmschrijving = story.content.og_description ? story.content.og_description : algemeen.og_description;
	var websiteNaam = algemeen.website_naam;
	var seoAfbeelding = story.content.og_image.filename ? story.content.og_image.filename : algemeen.og_image.filename;
	var fullSlug = story.full_slug == "homepage" ? "" : story.full_slug;
	var lang = story.lang == "default" ? "nl" : story.lang;

	const websiteSchema = {
	'@context': 'http://schema.org',
	'@graph': [
		{
			'@type': 'WebSite',
			author: {
				'@id': PUBLIC_WEBSITE_URL + '#identity'
			},
			copyrightHolder: {
				'@id': PUBLIC_WEBSITE_URL + '#identity'
			},
			copyrightYear: new Date().getFullYear().toString(),
			creator: {
				'@id': PUBLIC_WEBSITE_URL + '#creator'
			},
			datePublished: story.published_at,
			description: seoOmschrijving,
			headline: websiteNaam + ' | ' + seoTitel,
			image: {
				'@type': 'ImageObject',
				url: seoAfbeelding
			},
			inLanguage: lang,
			mainEntityOfPage: PUBLIC_WEBSITE_URL + "/" + fullSlug,
			name: websiteNaam + ' | ' + seoTitel,
			publisher: {
				'@id': PUBLIC_WEBSITE_URL + '#creator'
			},
			url: PUBLIC_WEBSITE_URL + "/" + fullSlug,
		},
		{
			'@id': PUBLIC_WEBSITE_URL + '#identity',
			'@type': 'Organization',
			address: {
				'@type': 'PostalAddress',
				addressCountry: algemeen.entiteit_land,
				addressLocality: algemeen.entiteit_stad,
				addressRegion: algemeen.entiteit_regio,
				postalCode: algemeen.entiteit_postcode,
				streetAddress: algemeen.entiteit_straat
			},
			description: algemeen.entiteit_omschrijving,
			email: algemeen.entiteit_email,
			logo: {
				'@type': 'ImageObject',
				url: algemeen.entiteit_logo.filename
			},
			name: websiteNaam,
			telephone: algemeen.entiteit_telefoonnummer,
			url: PUBLIC_WEBSITE_URL
		},
		{
			'@id': PUBLIC_WEBSITE_URL + '#creator',
			'@type': 'Organization',
			address: {
				'@type': 'PostalAddress',
				addressCountry: algemeen.entiteit_land,
				addressLocality: algemeen.entiteit_stad,
				addressRegion: algemeen.entiteit_regio,
				postalCode: algemeen.entiteit_postcode,
				streetAddress: algemeen.entiteit_straat
			},
			description: algemeen.entiteit_omschrijving,
			email: algemeen.entiteit_email,
			logo: {
				'@type': 'ImageObject',
				url: algemeen.entiteit_logo.filename,
			},
			name: websiteNaam,
			telephone: algemeen.entiteit_telefoonnummer,
			url: PUBLIC_WEBSITE_URL
		},
		{
			'@type': 'BreadcrumbList',
			description: 'Breadcrumbs list',
			itemListElement: [
				{
					'@type': 'ListItem',
					item: PUBLIC_WEBSITE_URL + "/" + fullSlug,
					name: story.content.titel,
					position: story.position
				}
			],
			name: 'Breadcrumbs'
		}
	]
};

</script>
<svelte:head>
	{@html serializeSchema(websiteSchema)}
</svelte:head>